import { ICart } from "../shopify_client"
import { shopifyGql, ShopifyGqlUserErrors } from "../shopify_client/graphql"
import { cartFragment } from "./fragments"

interface IUpdateItemQuantityArgs {
  cartID: string
  lineItemID: string
  quantity: number
}

export async function updateItemQuantity(
  { cartID, lineItemID, quantity }: IUpdateItemQuantityArgs,
): Promise<ICart> {
  const cartLinesUpdateInput = {
    cartId: cartID,
    lines: [ { id: lineItemID, quantity } ]
  }

  const { data, errors } = await shopifyGql<ICartLinesUpdateData>(
    cartLinesUpdateMutation,
    cartLinesUpdateInput
  )

  if (errors.length > 0) { throw new AggregateError(errors, 'updateItemQuantity.cartLinesUpdate') }

  return data.cartLinesUpdate.cart
}

interface ICartLinesUpdateData {
  cartLinesUpdate: {
    cart: {
      __typename: 'Cart'
    } & ICart
  } & ShopifyGqlUserErrors
}

const cartLinesUpdateMutation = `
mutation cartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
  cartLinesUpdate(cartId: $cartId, lines: $lines) {
    cart {
      ...CartFragment
    }
    userErrors {
      field
      message
    }
  }
}
${cartFragment}
`
